import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, DeleteUserDialogueHandler } from '../types';
import DeleteUserContext from './DeleteUserContext';
import { useTranslation } from 'react-i18next';

const { ConfirmationDialogue } = vp;

type DeleteUserDialogueProps = {
  handleDialogue: DialogueHandler<DeleteUserDialogueHandler>;
};

type FC = FunctionComponent<DeleteUserDialogueProps>;

const DeleteUserDialogue: FC = ({ handleDialogue }: DeleteUserDialogueProps) => {
  const { showDeleteUserSuccessAlert, showDeleteUserErrorAlert, showDeleteUserConfirmationAlert, DeleteUserError } =
    useContext(DeleteUserContext);
  const { t } = useTranslation('translations', { keyPrefix: 'Users.List.Dialog' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });

  return useMemo(
    () => (
      <div>
        {/* User Delete Confirmation */}
        <ConfirmationDialogue
          isVisible={showDeleteUserConfirmationAlert}
          title={t('UserDeleteConfirmation.title')}
          status="alert"
          subTitle={t('UserDeleteConfirmation.subTitle')}
          confirm={{
            label: tGlobal('yes'),
            action: () => handleDialogue({ type: 'alertDelete', state: 'success' }),
          }}
          cancel={{
            label: tGlobal('no'),
            action: () => handleDialogue({ type: 'alertDelete', state: 'fail' }),
          }}
        />
        {/* Delete User Error */}
        <ConfirmationDialogue
          isVisible={showDeleteUserErrorAlert}
          title={t('DeleteUserError.title')}
          status="error"
          subTitle={`${DeleteUserError}`}
          confirm={{
            label: t('DeleteUserError.confirmButton'),
            action: () => handleDialogue({ type: 'delete', state: 'fail' }),
          }}
        />
        {/* Delete User Success */}
        <ConfirmationDialogue
          isVisible={showDeleteUserSuccessAlert}
          title={t('DeleteUserSuccess.title')}
          status="success"
          subTitle={t('DeleteUserSuccess.subTitle')}
          confirm={{
            label: t('DeleteUserSuccess.confirmButton'),
            action: () => handleDialogue({ type: 'delete', state: 'success' }),
          }}
        />
      </div>
    ),
    [showDeleteUserSuccessAlert, showDeleteUserErrorAlert, showDeleteUserConfirmationAlert],
  );
};

export default DeleteUserDialogue;
